module.exports = __webpack_public_path__ + "img/photo_2023-05-16 19.14.57.51eca6b9.jpeg";